import React, { useEffect, useState } from "react";

const STEPS = [
  ["step-1", "Clarity"],
  ["step-2", "Authenticity"],
  ["step-3", "Being"],
  ["step-4", "Appreciation"],
  ["step-5", "Shadow"],
  ["protocol", "Protocol"],
];

export const ProgressBar = () => {
  const [pct, setPct] = useState(0);
  useEffect(() => {
    const on = () => {
      const h = document.documentElement.scrollHeight - window.innerHeight;
      setPct(h > 0 ? (window.scrollY / h) * 100 : 0);
    };
    window.addEventListener("scroll", on);
    return () => window.removeEventListener("scroll", on);
  }, []);
  return (
    <div className="progress-track"><div className="progress-fill" style={{ width: `${pct}%` }} data-testid="progress-fill" /></div>
  );
};

export const StepNav = ({ stage }) => {
  const [active, setActive] = useState("");
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActive(e.target.id)),
      { rootMargin: "-40% 0px -50% 0px" }
    );
    STEPS.forEach(([id]) => { const el = document.getElementById(id); if (el) obs.observe(el); });
    return () => obs.disconnect();
  }, [stage]);
  return (
    <nav className="step-nav" data-testid="step-nav">
      {STEPS.map(([id, name], i) => (
        <a key={id} href={`#${id}`} className={`${active === id ? "active" : ""} ${i + 1 > stage ? "locked" : ""}`} data-testid={`step-nav-${name.toLowerCase()}`}>
          <span className="num">{i + 1}</span><span className="nav-name">{name}</span>
        </a>
      ))}
    </nav>
  );
};

export const useRevealAll = () => {
  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add("in-view")),
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);
};
